module.exports = {
  oneToTwenty: require("./oneToTwenty"),
  tenMultiples: require("./tenMultiples"),
  hundredMultiples: require("./hundredMultiples"),
  thousandMultiples: require("./thousandMultiples")
};
